import React from 'react'
import CardLayout from '../../common/card-layout'

const CardContent = () => (
  <>
    <CardLayout title="Marine Refrigeration" image="marine-1.jpg">
      <p>
        We might have no idea on how to prepare the best frozen cocktails to serve
        on a yacht, but we know how to install the perfect refrigeration system for
        your vessel. We strongly value that moment, at the end of a sunny sailing
        day, when you want nothing more than to have a cold drink on your boat.
        <br />
        <br />
        Coast 2 Coast Refrigeration provides a wide range of refrigeration
        installation, maintenance and repair services. Our technical staff is
        just one call away for any installation advice you need, for any installation
        or maintenance projects you want to discuss with us, or for unwanted, but
        required emergency repairs.
        <br />
        We can deal with any electrical or mechanical issue, because we have highly
        qualified staff, proper equipment, and we always aim for the best customer
        experience.
      </p>
    </CardLayout>

    <CardLayout title="Installation" image="marine-2.jpg">
      <p>
        For us, an installation process means to choose the perfect refrigeration
        system for your boat. Also, if together we conclude it is not us that should
        do the installation, we are satisfied we could help you with the right advice!
        <br />
        <br />
        We can set up a refrigeration system from the ground-up for your boat.
        Adding a refrigeration on your vessel is not like going to a store, buy
        one and connect it to a source of power. You need to consider at least the
        following factors:
        <ul>
          <li>
            What type of power you have on board and how much battery the system will need,
          </li>
          <li>
            What space you have on the boat,
          </li>
          <li>
            Where to install the compressor,
          </li>
          <li>
            what kind of refrigeration box you need – think of size, colors
            and finishes, and location.
          </li>
        </ul>
        Call us and let’s search for the perfect refrigeration for your boat!
      </p>
    </CardLayout>

    <CardLayout title="Maintenance and Repair" image="marine-3.jpg">
      <p>
        Whether your vessel uses a drop-in unit, a cold-plate or a holding-plate
        system, our highly trained team can handle any issue you may encounter
        with the refrigeration system. Do you need an emergency repair? You can
        count on us in those moments when you need our services the most!
        <br />
        <br />
        <ul>
          <li>
            We take all the calls all the time
          </li>
          <li>
            We send professionals who employ the best repair techniques
          </li>
          <li>
            When replacements are required, we use the highest quality products
            for your refrigeration system
          </li>
        </ul>
        We cannot live with the image of you sailing with a broken refrigeration box
        that cannot keep your drinks cold or your fish catch frozen. For that, we are
        here to also provide maintenance service to keep your refrigeration system
        optimized for efficiency and to reduce the risks of emergency repairs.
        <br />
        <br />
        We deliver the maintenance services having one goal in mind: the refrigeration
        system should never let you down!
      </p>
    </CardLayout>
  </>
)
export default CardContent
